import { WarningCircle } from '@phosphor-icons/react';
import { useT } from '@/i18n/LanguageContext';

/**
 * <RequiredHints> — 「要入力」の出し方（仕様 2.1 / 4）。
 *
 * **警告だけで、保存は止めない。** 新規登録のときだけ ＊ を付け、
 * 未入力の項目名をここに並べる。既存データは書き換えないので、古い行を
 * 開いた人を叱らない。
 */
export const RequiredHints = ({ missing = [], testId = 'required-hints', title = null }) => {
  const { t } = useT();
  if (!missing.length) return null;
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[12px] text-amber-800"
      data-testid={testId}>
      <p className="flex items-center gap-1.5 font-semibold">
        <WarningCircle size={13} />
        {title || t('reg.required.title')}
      </p>
      <p className="mt-0.5 text-amber-700" data-testid={`${testId}-list`}>
        {missing.map((m) => `「${m}」`).join('、')}
      </p>
    </div>
  );
};

export default RequiredHints;
